export enum ActiveSellersEnum {
  'Todos' = 'Todos',
  'Ativos' = 'Ativos',
  'Desativos' = 'Desativos',
}

export const ActiveStatusMap = (status: ActiveSellersEnum): boolean | null => {
  const active = {
    [ActiveSellersEnum.Todos]: null,
    [ActiveSellersEnum.Desativos]: false,
    [ActiveSellersEnum.Ativos]: true,
  };

  return active[status];
};
